import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Form,
	Modal
} from 'semantic-ui-react';

import useForm from '../../../../../hooks/useForm';

import { assignCoordination } from '../../../../../api/nora/programs';

import { useProgramState } from '../../../../../contexts/ProgramsContext';
import { useUIAction } from '../../../../../contexts/UIContext';

import FormSelect from '../../../../Form/FormSelect';

const CoordinationModal = ( {
	closeModal,
	open,
	retrieveCoordinationList
} ) => {
	const {
		program,
		coordinationOptions
	} = useProgramState();
	const { setApiErrorAlert } = useUIAction();

	const {
		formData,
		updateField,
		setFormData
	} = useForm( { user: 0 } );

	const handleCloseModal = useCallback( async () => {
		setFormData( { user: 0 } );
		await retrieveCoordinationList();
		closeModal();
	}, [
		setFormData,
		retrieveCoordinationList,
		closeModal
	] );

	const handleAssign = useCallback( async () => {
		try {
			await assignCoordination( program?.id, [ formData.user ] );
		} catch ( error ) {
			setApiErrorAlert( error );
		}

		handleCloseModal();
	}, [
		formData.user,
		handleCloseModal,
		program,
		setApiErrorAlert
	] );

	return (
		<Modal
			open={ open }
			size="tiny"
		>
			<Modal.Header>Add Coordinator to Program</Modal.Header>
			<Modal.Content>
				<Form>
					<FormSelect
						fieldLabel="Select A User"
						name="user"
						onChange={ updateField }
						options={ coordinationOptions }
						search
						value={ formData.user || '' }
						width={ 10 }
					/>
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button
					content="Add"
					disabled={ !formData.user }
					onClick={ handleAssign }
				/>
				<Button
					content="Cancel"
					onClick={ handleCloseModal }
				/>
			</Modal.Actions>
		</Modal>
	);
};

CoordinationModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	open: PropTypes.bool,
	retrieveCoordinationList: PropTypes.func.isRequired
};

export default CoordinationModal;
